









































































// Vue
import { defineComponent, PropType, computed } from '@vue/composition-api'

// components
import TaskTableBody from './TaskTableBody.vue'

// models
import { TaskSheet } from '@/models/taskSheet'

export default defineComponent({
  name: 'TableTask',
  components: {
    TaskTableBody
  },
  props: {
    taskSheet: {
      required: true,
      type: Object as PropType<TaskSheet>
    },
    workType: {
      required: true,
      type: Number as PropType<number>
    },
    date: {
      required: true,
      type: String as PropType<string>
    },
    actionForm: {
      required: true,
      type: String
    }
  },
  setup (props) {
    const headers = computed(() => {
      const headers1 = [
        { text: 'Nª', key: 'index' },
        { text: 'Apelllidos y Nombre', key: 'employeeText' },
        { text: 'H.I Reloj', key: 'timeInDevice' },
        { text: 'H.S Reloj', key: 'timeOutDevice' },
        { text: 'H.I', key: 'timeIn' },
        { text: 'H.S', key: 'timeOut' },
        { text: 'Refrigerio', key: 'lunch' },
        { text: 'Hora Refrigerio', key: 'timeLunch' },
        { text: 'H. Normal Real', key: 'timeTotalReal' },
        { text: 'H. Normal', key: 'timeTotal' },
        { text: 'H. Extra 25%', key: 'timeExtra25' },
        { text: 'H. Extra 35%', key: 'timeExtra35' },
        { text: 'H.E.D', key: 'timeHed' },
        { text: 'H. Nocturno', key: 'timeTotalN' },
        { text: 'H. Noc Extra 25%', key: 'timeExtra25N' },
        { text: 'H. Noc Extra 35%', key: 'timeExtra35N' },
        { text: 'Sit. Pers.', key: 'condition' },
        { text: 'Tipo Trab.', key: 'workType' },
        { text: 'Observaciones', key: 'observations' }
      ]
      const headers2 = [
        { text: 'Nª', key: 'index' },
        { text: 'Apelllidos y Nombre', key: 'employeeText' },
        { text: 'H.I Reloj', key: 'timeInDevice' },
        { text: 'H.S Reloj', key: 'timeOutDevice' },
        { text: 'H.I', key: 'timeIn' },
        { text: 'H.S', key: 'timeOut' },
        { text: 'Refrigerio', key: 'lunch' },
        { text: 'H.N', key: 'timeTotal' },
        { text: 'H.E 25%', key: 'timeExtra25' },
        { text: 'H.E 35%', key: 'timeExtra35' },
        { text: 'Sit. Pers.', key: 'condition' },
        { text: 'Tipo Trab.', key: 'workType' },
        { text: 'Importes', key: 'amounts' }
      ]
      return props.workType === 1 ? headers1 : headers2
    })

    const totalHours = computed(() => {
      let total = 0
      props.taskSheet.items.forEach(item => {
        total += item.timeTotal
      })
      return total
    })

    const totalExtra25 = computed(() => {
      let total = 0
      props.taskSheet.items.forEach(item => {
        total += item.timeExtra25
      })
      return total
    })

    const totalExtra35 = computed(() => {
      let total = 0
      props.taskSheet.items.forEach(item => {
        total += item.timeExtra35
      })
      return total
    })

    const totalNocturnal = computed(() => {
      let total = 0
      props.taskSheet.items.forEach(item => {
        total += item.timeTotalN
      })
      return total
    })

    const totalNocturnal25 = computed(() => {
      let total = 0
      props.taskSheet.items.forEach(item => {
        total += item.timeExtra25N
      })
      return total
    })
    const totalNocturnal35 = computed(() => {
      let total = 0
      props.taskSheet.items.forEach(item => {
        total += item.timeExtra35N
      })
      return total
    })

    return {
      headers,
      totalHours,
      totalExtra25,
      totalExtra35,
      totalNocturnal,
      totalNocturnal35,
      totalNocturnal25
    }
  }
})
